export default __webpack_public_path__ + "static/media/noa-28.6c15f801.jpg";